import DetailPeluang from './DetailPeluang';

export default DetailPeluang;
